import { render, staticRenderFns } from "./EditInterviewFormatBasicDetailsDialog.vue?vue&type=template&id=224c48db&"
import script from "./EditInterviewFormatBasicDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditInterviewFormatBasicDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports